import { render, staticRenderFns } from "./FontManagerModal.vue?vue&type=template&id=4537100c&scoped=true"
import script from "./FontManagerModal.vue?vue&type=script&lang=js"
export * from "./FontManagerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537100c",
  null
  
)

export default component.exports